import React from 'react'

import { Notice } from '@cgtrader/triangle-ui/dist/src/ssr-index'

const icon = (
  <div className="promote-modal__notice-icon-container">
    <span style={{ fontSize: '24px' }}>💡</span>
  </div>
)

function ContactSupportBanner() {
  return (
    <Notice type="primary" useSSRIcon ssrIcon={icon} className="promote-modal__notice">
      <div className="cgt-ml-10">
        <b>Out of credits?</b> Contact our support team at{' '}
        <a href="mailto:support@cgtrader.com">support@cgtrader.com</a> or use the{' '}
        <a href="https://help.cgtrader.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer">
          request form
        </a>{' '}
        to purchase additional credits at a
        custom price!
      </div>
    </Notice>
  )
}

export default ContactSupportBanner
